module.exports = __webpack_public_path__ + "static/img/paytype2_demo.31a3bf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paytype2_demo.jpg
// module id = q4Gh
// module chunks = 171